import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {FileManagementService} from '@core/services/file-management.service';
import {StringUtility} from '@shared/utility/string-utility';
import {CollaborationState} from '../../store/collaboration.reducer';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {SetCurrentRightSideComponentAction} from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import {SupportChatComponentName} from '../../store/collaboration.constants';
import {ContentScope} from "@shared/commands/command-base";
import {CommandService} from "@core/services/command.service";
import {DownloadFileCommand} from "../../../../file-manager/commands/create-directory.command";
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {Configuration} from "@shared/models/configuration";
import {getClaims, hasFeature} from "@shared/store/selectors/security.selector";
import {take, takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";

@Component({
    standalone: false,
    selector   : 'particle-help-support',
  templateUrl: './help-support.component.html',
  styleUrls  : ['./help-support.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HelpSupportComponent implements OnInit, OnDestroy  {
  public helpRequestList: any[];
  public releaseNotes: any[];
  orbitaxServicesResources = [];
  isHelpRequestListVisible: boolean;
  isReleaseNotesVisible: boolean;
  isOrbitaxServicesVisible: boolean;
  isDAC6MdrResourceVisible: boolean;
  orbitaxTutorialsAttributes: any;
  isOrbitaxVideosVisible: boolean;
  /*= [
    {
      title   : 'Project Settings',
      path    : 'Root/Collaboration/HelpSupport/project-settings.pdf',
      fileName: 'project-settings.pdf'
    }, {
      title   : 'Task Manager',
      path    : 'Root/Collaboration/HelpSupport/task-manager.pdf',
      fileName: 'task-manager.pdf'
    }
  ];*/
   helpCenterURL: any;
  public unSubscribe$ = new Subject<void>();
  constructor (private collaborationStore: Store<CollaborationState>,
               protected commandService: CommandService,
               private dialogService: DialogService,
               private platformSidebarStore: Store<PlatformSidebarState>,
               private fileManagementService: FileManagementService) { }



  ngOnInit () {
    this.helpCenterURL = Configuration.getConfig("HelpCenterURL");
    this.platformSidebarStore.select(getClaims).pipe(take(1)).subscribe(claims => {
        if(claims['product_codes'].includes("itp-visitor")){
          this.helpCenterURL = "";
        }
    });
    this.isHelpRequestListVisible = false;
    this.isReleaseNotesVisible = false;
    this.isOrbitaxServicesVisible = false;
    //this.isDAC6MdrResourceVisible = true;
    this.isOrbitaxVideosVisible = false;
    this.fileManagementService.getHelpSupportFilesList().subscribe((files: any[]) => {
      this.helpRequestList = files.filter(file => file.isDeleted === false && file.isFolder === false);
      this.helpRequestList.forEach(file => {
        file.title = this.formatTitle(file.name);
      });
    });
    this.fileManagementService.getReleaseNoteFilesList().subscribe((files: any[]) => {
      this.releaseNotes = files.filter(file => file.isDeleted === false && file.isFolder === false);
      this.releaseNotes.forEach(file => {
        file.title = this.formatTitle(file.name);
      });
    });
    this.fileManagementService.getOrbitaxServicesResourceList().subscribe( res => {
      if(res) {
        this.orbitaxServicesResources = res.orbitaxServicesResourceAttributes;
        this.orbitaxTutorialsAttributes = res.orbitaxTutorialsAttributes
      }
    });
  }

  formatTitle (fileName: string): string {
    fileName = StringUtility.getFileNameExcludingExtension(fileName);
    let newName = '';
    fileName.split('-').forEach(word => {
      word = word[0].toUpperCase() + word.slice(1, word.length);
      newName += word + ' ';
    });
    return newName.trim();
  }

  customerSupport () {
    this.platformSidebarStore.dispatch(new SetCurrentRightSideComponentAction({component: SupportChatComponentName, data: {}, componentInfo: null}));
  }

  contactThomsonReuters() {
    window.open('https://tax.thomsonreuters.com/site/support/onesource/dac6-Reporter/');
  }
  openDetailsPopUp(item){
    const details = item.viewDetailString;
    const dialogModel: DialogModel = DialogModel.create(
      item.title,
      'ViewDetailsComponent',
      {
        viewDetails: details
      },
      '600px',
      '700px'
    );
    dialogModel.okCaption = 'Done';
    dialogModel.cancelCaption = '';
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      // console.log(res);
    });
  }
  download (item: any) {
    const downloadFileCommand = new DownloadFileCommand(item.id, '', false, item.name);
    downloadFileCommand.scope = ContentScope.Default;
    this.commandService.executeCommand(downloadFileCommand).pipe().subscribe(data => {
      if(data && data.Payload && data.Payload.DownloadUrl) {
        let url = data.Payload.DownloadUrl;
        url = `${url}&demoId=${''}&inlineFileType=${true}`;
        this.fileManagementService.openLinkInNewTab(url, item.name);
      }
    });
/*    this.fileManagementService.downloadFileByRelativePath(item.relativePath).subscribe(data => {
      this.fileManagementService.openSaveFileWindow(data, item.name);
    });*/
  }

  onDownload() {
    const downloadFileCommand = new DownloadFileCommand('93947f8a-2639-41dc-97c9-386c368148a6', '', false, 'chense.pdf');
    downloadFileCommand.scope = ContentScope.Default;
    this.commandService.executeCommand(downloadFileCommand).pipe().subscribe(data => {
      console.log('data:', data);
      if(data && data.Payload && data.Payload.DownloadUrl) {
        let url = data.Payload.DownloadUrl;
        console.log('download url:', url);
        url = `${url}&demoId=${''}&inlineFileType=${true}`;
        this.fileManagementService.openLinkInNewTab(url, 'chense.pdf');
      }
    });
  }

  toggleHelpRequestList(){
    this.isHelpRequestListVisible = !this.isHelpRequestListVisible;
  }
  toggleReleaseNotes(){
    this.isReleaseNotesVisible = !this.isReleaseNotesVisible;
  }
  toggleOrbitaxServices(){
    this.isOrbitaxServicesVisible = !this.isOrbitaxServicesVisible;
  }
  toggleDAC6MdrResource(){
    this.isDAC6MdrResourceVisible = !this.isDAC6MdrResourceVisible;
  }
  toggleOrbitaxVideos(){
    this.isOrbitaxVideosVisible = !this.isOrbitaxVideosVisible;
  }

  openHelpCenter() {
    window.open(this.helpCenterURL);
  }
  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
}
